type Testimonial = {
  quote: string;
  name: string;
  title: string;
  city: string;
  photoUrl?: string;
};

type Props = {
  testimonials: Testimonial[];
};

export default function TestimonialSection({ testimonials }: Props) {
  if (testimonials.length === 0) return null;

  return (
    <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <h2 className="text-2xl md:text-3xl font-bold text-center mb-10 text-slate-900 dark:text-white">
        Was Berater sagen
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {testimonials.map((t) => (
          <div
            key={t.name}
            className="rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800/60 p-6 flex flex-col gap-4"
          >
            <p className="text-sm leading-relaxed text-slate-600 dark:text-slate-300 italic">
              &ldquo;{t.quote}&rdquo;
            </p>
            <div className="flex items-center gap-3 mt-auto">
              {t.photoUrl && (
                <img
                  src={t.photoUrl}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
              )}
              <div>
                <div className="font-semibold text-sm text-slate-900 dark:text-white">{t.name}</div>
                <div className="text-xs text-slate-500 dark:text-slate-400">{t.title}, {t.city}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
